// extracted by mini-css-extract-plugin
export default {"btn":"secondaryButton_btn__4SjgK9Jg","default":"secondaryButton_default__c3T+VYk7","active":"secondaryButton_active__BbV4miqx"};